import { render, staticRenderFns } from "./VaIcon.vue?vue&type=template&id=7e49e1ec&"
import script from "./VaIcon.vue?vue&type=script&lang=js&"
export * from "./VaIcon.vue?vue&type=script&lang=js&"
import style0 from "./VaIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports